var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var _getMediaCondition = function (imageSourceSetElement, lazyLoad) {
    return "@media only screen " + (imageSourceSetElement.mediaCondition ? "and (" + imageSourceSetElement.mediaCondition + ")" : '') + " {\n        background: url('" + imageSourceSetElement.src + "') no-repeat left center;\n        background-size: cover;\n\n        " + (lazyLoad &&
        "\n        background-image: unset;\n\n        &.visible {\n            background-image: url('" + imageSourceSetElement.src + "');\n        }\n        ") + ";\n    };";
};
export var BackgroundContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: url('", "') no-repeat left center;\n    background-size: cover;\n\n    ", ";\n\n    ", "\n"], ["\n    background: url('", "') no-repeat left center;\n    background-size: cover;\n\n    ", ";\n\n    ", "\n"])), function (_a) {
    var baseImageSource = _a.baseImageSource;
    return baseImageSource;
}, function (_a) {
    var lazyLoad = _a.lazyLoad, baseImageSource = _a.baseImageSource;
    return lazyLoad &&
        "\n        background-image: unset;\n\n        &.visible {\n            background-image: url('" + baseImageSource + "');\n        }\n    ";
}, function (_a) {
    var imageSourceSet = _a.imageSourceSet, lazyLoad = _a.lazyLoad;
    return imageSourceSet
        ? imageSourceSet.reduce(function (previousResult, currentImageSource) {
            return (previousResult += _getMediaCondition(currentImageSource, lazyLoad));
        }, '')
        : '';
});
var templateObject_1;
